module.exports = __webpack_public_path__ + "media/assets/transfer/transports/minibus.22913219-229132193691237d9a912916a48b3ec2.png";